import { describeUploadFiles } from './describe-upload-files';
import type {
  DocumentUploadSource,
  DocumentUploadTelemetryContext,
} from './types';

export function buildDocumentUploadTelemetryContext({
  source,
  dealId,
  packageId,
  flowId,
  files,
  pathname,
  skipParserCacheRead,
  skipParserCacheWrite,
}: {
  source: DocumentUploadSource;
  dealId: string;
  packageId: string;
  flowId?: string;
  files: File[];
  pathname?: string;
  skipParserCacheRead?: boolean;
  skipParserCacheWrite?: boolean;
}): DocumentUploadTelemetryContext {
  const described = describeUploadFiles(files);
  return {
    source,
    dealId,
    packageId,
    ...(flowId ? { flowId } : {}),
    ...described,
    ...(pathname ? { pathname } : {}),
    ...(skipParserCacheRead ? { skipParserCacheRead: true } : {}),
    ...(skipParserCacheWrite ? { skipParserCacheWrite: true } : {}),
  };
}
